module.exports = __webpack_public_path__ + "static/media/read.ccd1be1f.svg";